module.exports = __webpack_public_path__ + "static/media/29DUNON3.b6b85115.jpg";